module.exports = __webpack_public_path__ + "assets/img/media_19.b087e609.png";